
(() => {
    console.log('%c👍🏼 Hero', 'color: yellow');
    const videoElements = document.querySelectorAll('section.hero video');

    const setupAudioToggle = (videoElement) => {
        const audioToggle = videoElement.parentElement.querySelector('.hero__audio-toggle');
        const muteIcon = audioToggle.querySelector('[data-audio-toggle="mute"]');
        const unmuteIcon = audioToggle.querySelector('[data-audio-toggle="unmute"]');

        const toggleAudio = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // if video sound is on, turn it off
            if (!videoElement.muted) {
                videoElement.muted = true;
                muteIcon.classList.add('hidden');
                unmuteIcon.classList.remove('hidden');
            } else {
                videoElement.muted = false;
                muteIcon.classList.remove('hidden');
                unmuteIcon.classList.add('hidden');

                if (!audioToggle.dataset.clicked) {
                    audioToggle.dataset.clicked = 'true';
                    // restart video
                    videoElement.currentTime = 0;
                    videoElement.play();
                }
            }
        };

        // Add click event listener
        audioToggle.addEventListener('click', toggleAudio);
    };


    function updateVideoSource(videoElement) {
        if (!videoElement) return;

        const mobileVideoSrc = videoElement.getAttribute('data-mobile-video');
        const desktopVideoSrc = videoElement.getAttribute('data-desktop-video');
        const isDesktop = window.innerWidth >= 1024;
        const sourceElement = videoElement.querySelector('source');

        if (!sourceElement) return;

        const currentSrc = sourceElement.getAttribute('src');
        const newSrc = isDesktop ? desktopVideoSrc : mobileVideoSrc;

        if (currentSrc !== newSrc) {
            sourceElement.setAttribute('src', newSrc);
            videoElement.load();
            videoElement.play();
        }
    }

    videoElements.forEach(videoElement => {
        const blurbBox = videoElement.parentElement.querySelector('.hero__blurb');
        if (blurbBox) {
            setTimeout(() => {
                blurbBox.classList.remove('opacity-0', 'scale-50');
            }, 500);
        }
        // Initial check
        updateVideoSource(videoElement);
        const heroAudioToggle = videoElement.parentElement.querySelector('.hero__audio-toggle');
        if (heroAudioToggle) {
            setupAudioToggle(videoElement);
        }
    });

    // Update on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            videoElements.forEach(videoElement => updateVideoSource(videoElement));
        }, 250);
    });
})();